import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgImageSliderComponent } from 'ng-image-slider';
import { NotificationService } from 'src/app/Service/notification.service';
import { CommonService } from 'src/app/Service/Common.service';
import { IncidentManagerService } from 'src/app/Service/incident-tool/incident-tool.service';

export interface slider {
  image: string;
  thumbImage: string;
  title: string;
}

@Component({
  selector: 'app-helpdesk-support-details',
  templateUrl: './helpdesk-support-details.component.html',
  styleUrls: ['./helpdesk-support-details.component.css']
})
export class HelpdeskSupportDetailsComponent implements OnInit {
  helpdesk_Detail_desc: any;
  helpdesk_Summary: any;
  matCatClear = 'N';
  eipUserId!:number;
  @ViewChild('nav') slider!: NgImageSliderComponent;

  imageObject: Array<slider> = [];
  helpdeskImgList :any= [];
  emittedDTDOPTSubscriber!: Subscription;
  emittedDTDOPTList: any[] = [];

  slider1!: slider;
  reqData: any;
  selectedimages: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,
    public dialogRef: MatDialogRef<HelpdeskSupportDetailsComponent>,
    private _notificationService: NotificationService,
    private commonService: CommonService,
    private incidentManagerService : IncidentManagerService
  ) {
    this.helpdeskImgList = data.imgList;
  }

  ngOnInit() {
    this.eipUserId = this.commonService.getLoggedInUserEipUserId();
    // this.emittedDTDOPTSubscriber = this.eipCommonSvc.emittedDoptList.subscribe(value => {
    //   this.emittedDTDOPTList = value;
    // });
    for (var i = 0; i < Object.keys(this.helpdeskImgList).length; i++) {
      this.slider1 = {
        image: this.helpdeskImgList[i].Base64,
        thumbImage: this.helpdeskImgList[i].Base64,
        title: 'Screenshot - ' + i
      }
      this.imageObject.push(this.slider1);
      this.selectedimages.push(this.slider1.title);
    }
  }

  imageClickHandler(e:any) {
   
  }

  prevImageClick() {
    this.slider.prev();
  }

  nextImageClick() {
    this.slider.next();
  }
  closeDialog() {
    this.dialogRef.close();
  }

  async HelpdeskSend() {
    if (this.helpdesk_Detail_desc == '' || this.helpdesk_Detail_desc == undefined || this.helpdesk_Detail_desc == null) {
      const message = {
        messageSeverity: '0',
        messageText: 'Please enter the Issue Detail.'
      };
      this._notificationService.showPopupMessageBox(message, this.cancelOkHandler.bind(this), this.cancelOkHandler.bind(this));
      return;
    }

    // creating input for uploading
    const imgList:any = [];
    const input:any = {
      jsonAttach: [],
      Tuid: this.eipUserId,
      priority: 'Medium',
      summary: '',
      problem_details: this.helpdesk_Detail_desc,
      ip_address: '',
      dtCode: 1234,
      jsonSessionData: '',
      jsonFormData: ''
    };
    if (this.helpdeskImgList.length > 0) {
      this.helpdeskImgList.forEach((image:any, i:any) => {
        const reqData = {
          ModuleName: 'HDS',
          DocumentType: 'InternalDocuments',
          File: Object.keys(image.bytes).map(key => image.bytes[key]),
          FileName: `Screenshot-${i}.png`,
          FileDescription: 'Help Desk Screenshot',
          DocumentId: '',
          DocType: '1234',
          UID: 1692687
        };
        this.incidentManagerService.uploadIncidentScreenshot(reqData).subscribe((resData: any) => {
          imgList.push({
            sFileName: `Screenshot-${i}.png`,
            iFileSize: image.bytes.length,
            sOrgFileName: `Screenshot-${i}.png`,
            iSPSID: resData[0].UniqueID,
            sSPSDocLibrary: 'HelpdeskDocs',
            sSPS_Site_URL: ''
          });
          if (imgList.length === this.helpdeskImgList.length) {
            input.jsonAttach = imgList;
            this.InsertINCDetails(input);
          }
        });
      });
    } else {
      this.InsertINCDetails(input);
    }
  }

  InsertINCDetails(data: any) {
    this.incidentManagerService.createIncident(data).subscribe((responseData: any) => {
      this.imageObject = [];
      const message = {
        messageSeverity: '1',
        messageText: 'Ticket Number :' + responseData.configValue,
      };
      this._notificationService.showPopupMessageBox(message, this.cancelOkHandler.bind(this), this.cancelOkHandler.bind(this));
    });
  }

  cancelOkHandler() {
    // do nothing
    this.commonService.clearImgList.next(true);
    this.dialogRef.close();
  }
}
